import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export default function UserDashboard() {
  const { user, csrfToken, logout } = useAuth(); // استفاده از logout از context
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { data } = await axios.get('/user/profile');
      setProfile(data.profile);
    })();
  }, []);

  const handleLogout = async () => {
    await logout();          // پاک کردن کاربر از context
    navigate('/', { replace: true }); // برگرد به صفحه اصلی
  };

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h4">User Dashboard</h1>
        <div className="d-flex gap-2">
          {user?.role === 'admin' && (
            <Link to="/admin" className="btn btn-outline-primary">Admin Panel</Link>
          )}
          <button className="btn btn-outline-secondary" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center gap-3">
            {profile?.avatarUrl && (
              <img src={profile.avatarUrl} alt="avatar" className="rounded-circle" width={56} height={56} />
            )}
            <div>
              <div className="fw-bold">{user?.name || 'User'}</div>
              <div className="text-muted">{user?.email}</div>
              <span className="badge bg-secondary mt-2">{user?.role}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
